import React from "react";
import PropTypes from "prop-types";
import StyledDropDownRadioBundle from "./DropDownRadioBundle.styled";
import SVGIcon from "../../../components/utility/SVGIcon";

const DropDownRadioBundle = React.memo(props => {
  const { range, checked, value,name, getId, onChange } = props;
  return (
    <StyledDropDownRadioBundle className={`dropdown-sort__radio ${checked && "is-checked"}`}>
      <input  checked={checked} value={value} onChange={onChange} onClick={(e) => getId(e)} aria-label={name} id={range.id}   type="radio" />
      <span className="filter-product-type__checkbox__custom">
        {checked ?
        <>
          <SVGIcon name="filter-check-arrow" className="filter-check-arrow"/>
          <SVGIcon name="filter-check-square" className="filter-check-square"/>
        </>
        : <SVGIcon name="bundle_filter-checkbox"/>}
      </span>
      <span className="t-body-small dropdown-sort__radio__copy">{range.name}</span>
    </StyledDropDownRadioBundle>
  );
});

DropDownRadioBundle.propTypes = {
  range: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired
};

export default DropDownRadioBundle;